import { Dialog, DialogPanel, DialogTitle, DialogBackdrop } from '@headlessui/react'
import { BlackActionButton } from '../buttons/BlackActionButton'

interface IOkDialogProps {
  isOpen: boolean
  onClose: () => void
  title: string
  content: string
  okLabel?: string
}

export const OkDialog = (props: IOkDialogProps) => {
  const {
    isOpen,
    onClose,
    title,
    content,
    okLabel = 'OK'
  } = props

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-black/30" />
      
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
          <DialogTitle className="text-lg font-semibold text-gray-900">
            {title}
          </DialogTitle>
          
          <div className="mt-3 text-gray-600">
            {content}
          </div>

          <div className="mt-6 flex justify-end">
            <div onClick={onClose}>
              <BlackActionButton label={okLabel} />
            </div>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  )
}
